export const userViewsGWPSelectionPage = () => ({
  type: 'User views GWP Selection page',
});

export const userSelectsGWP = ({ option }) => ({
  type: 'GWP Selected',
  data: {
    option,
  },
});

export const userContinuesFromGWPStep = ({ option }) => {
  return {
    type: 'User continues from Gift With Purchase',
    data: {
      option,
    },
  };
};
